import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef } from '@angular/core';
import { Transaction } from './../../../models/transaction';
import { TokenServiceService } from '../../../services/token-service.service';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { createMerchantReturnUrl } from '../../helps/helps';

@Component({
    selector: 'app-buttons-bar',
    templateUrl: './buttons-bar.component.html',
    styleUrls: ['./buttons-bar.component.scss'],
})
export class ButtonsBarComponent implements OnInit {
    @ViewChild('printCash') elem: ElementRef;
    @Input() template: string;
    @Input() order: string;
    @Input() redirect: string;
    @Input() nameCustom: string;
    @Input() valid = false;
    @Output() PR = new EventEmitter();
    @Output() CUSTOM = new EventEmitter();
    @Output() PAY = new EventEmitter();

    orderID: string;
    urlReturnMerchant: string;
    transaction: Transaction;
    buttonPay: boolean;
    buttonPrint: boolean;
    buttonEnd: boolean;
    returnURL: boolean;
    token: string;
    goBackVisible: boolean;

    constructor(private readonly tokenServiceService: TokenServiceService) { }

    async ngOnInit() {
        await this.handleButtonsVisible();
    }

    async handleButtonsVisible() {
        this.buttonPay = false;
        this.buttonEnd = false;
        this.buttonPrint = false;
        await this.getUrlReturnMerchant();

        if (this.PAY.observers.length > 0) {
            this.buttonPay = true;
        } else {
            for (const template of Object.values(GENERAL_CONSTANTS.TEMPLATES)) {
                if (template === this.template) {
                    this.buttonEnd = true;
                }
            }
        }
        if (this.PR.observers.length > 0) {
            this.buttonPrint = true;
        }
    }

    backToMerchant() {
        window.location.href = this.redirect;
    }

    getUrlReturnMerchant() {
        this.transaction = this.tokenServiceService.getAndDecodeToken();
        let returnURL = createMerchantReturnUrl(this.orderID, this.transaction.MERCHANT_URL_RETURN);

        if (returnURL) {
            this.urlReturnMerchant = returnURL;

            return;
        }

        this.returnURL = false;
    }

    print() {
        this.PR.emit();
    }

    pay() {
        this.PAY.emit();
    }

    custom() {
        this.CUSTOM.emit();
    }
}
